import { render, staticRenderFns } from "./HomeComponent.vue?vue&type=template&id=636fae52&scoped=true&"
import script from "./HomeComponent.vue?vue&type=script&lang=js&"
export * from "./HomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636fae52",
  null
  
)

export default component.exports